
export const mockApplications = [
  {
    id: "APP-2023-001",
    borrower_name: "Alice Johnson",
    amount: 15000,
    credit_score: "720",
    application_date: "2023-10-25",
    status: "pending",
  },
  {
    id: "APP-2023-002",
    borrower_name: "Bob Smith",
    amount: 30000,
    credit_score: "680",
    application_date: "2023-10-26",
    status: "review",
  },
  {
    id: "APP-2023-003",
    borrower_name: "Carol Williams",
    amount: 50000,
    credit_score: "750",
    application_date: "2023-10-20",
    status: "approved",
  },
  {
    id: "APP-2023-004",
    borrower_name: "David Miller",
    amount: 10000,
    credit_score: "620",
    application_date: "2023-10-28",
    status: "declined",
  },
  {
    id: "APP-2023-005",
    borrower_name: "Emma Davis",
    amount: 25000,
    credit_score: "710",
    application_date: "2023-10-24",
    status: "pending",
  },
];
